import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { LiveReserveContext } from '../../LiveLessonReseveContext';
import Modal from '../../../../../common/Modal';
import LiveReserveSelectInstructorSelect from './select/LiveReserveSelectInstructorSelect';
import LiveReserveSelectInstructorModal from './modal/LiveReserveSelectInstructorModal';
import LiveReserveSelectInstructorRequest from './modal/request/LiveReserveSelectInstructorRequest';

import { LiveReserveInstructorModel } from '../../../../../../models/lesson/live/reserve/instructor/LiveReserveInstructor';


// 講師選択
function LiveReserveSelectInstructor() {
  const isPc = useContext(cmnContext).isPc;

  const {
    isLoading,
    instId,
    instructors,
  } = useContext(LiveReserveContext);

  const [selectInst, setSelectInst] = useState<LiveReserveInstructorModel | null>(null);
  // 講師未選択画像
  const noSelectImg = '/images/page/lesson/live/noselect_inst.png';

  const [isDispModal, setIsDispModal] = useState<boolean>(false);
  const [isDispRequest, setIsDispRequest] = useState<boolean>(false);


  // 選択講師情報
  useEffect(() => {
    // 選択講師データ
    const newSltInst = instructors.find((inst: any) => inst.inst_id === instId);
    setSelectInst(newSltInst);
  }, [isLoading, instId])


  // 講師情報から画像取得
  function getInstImg(inst: any) {
    // (API処理)設定されていてもサーバ上に画像ファイルがなければデフォルト
    let imgSrc = '';
    if(inst.image_file) {
      // 画像設定
      const now = new Date();
      const yearMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
      imgSrc = `/images/instructor/${inst.image_file}?${yearMonth}`;
    } else if(inst.gender == '1') {
      // 男性
      imgSrc = '/images/page/lesson/live/noimage_male.png';
    } else {
      // 女性
      imgSrc = '/images/page/lesson/live/noimage_female.png';
    }
    return imgSrc;
  }
  // 講師の趣味・スコア情報
  function getInstDetailInfo(inst: any) {
    // 講師情報
    let newInfo = '';
    if(inst) {
      if(inst.hobby) {
        // 趣味
        newInfo = inst.hobby;
      } else if(inst.score) {
        // スコア
        newInfo = inst.score;
      }
      // 改行除去
      newInfo = newInfo.replace(/\n/g, ' ');
    }

    return newInfo;
  }


  
  return (
    <div style={{marginBottom: 10}}>
      <label className="control-label" style={{
        margin: '15px 0 5px 0',
        backgroundColor: '#eaffea',
        padding: '0.25em 3em 0.25em 0.5em',
        borderLeft: 'solid 5px #3c8c3c',
      }}>レッスンを受ける講師を選択</label>

      <div style={{marginBottom: isPc? '0': '5px'}}>
        <input type="hidden" name="inst_id" value={instId} />

        {/* 選択講師 */}
        <LiveReserveSelectInstructorSelect
          setIsDispModal={setIsDispModal}
          selectInst={selectInst}
          noSelectImg={noSelectImg}
          getInstImg={getInstImg}
          getInstDetailInfo={getInstDetailInfo}
        />

        {/* 選択モーダル */}
        <Modal
          comp={
            <LiveReserveSelectInstructorModal
              selectInst={selectInst}
              setIsDispModal={setIsDispModal}
              getInstImg={getInstImg}
              getInstDetailInfo={getInstDetailInfo}
              setIsDispRequest={setIsDispRequest}
            />
          }
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          modalWidth={isPc? '60%' : '95%'}
        />
      </div>


      {/* 講師リクエストモーダル */}
      <Modal
        comp={
          <LiveReserveSelectInstructorRequest
            setIsDispModal={setIsDispRequest}
          />
        }
        isDispModal={isDispRequest}
        setIsDispModal={setIsDispRequest}
        modalWidth={isPc? '60%' : '95%'}
        modalMaxHeight={isPc? '85vh' : '85vh'}
        isDispClose={true}
        isBackClose={false}
      />

    </div>
  );
}
  
export default LiveReserveSelectInstructor;